<script setup lang="ts"></script>

<template>
  <section class="lg:flex lg:space-x-4">
    <div class="mb-4 lg:w-48 xl:w-64 w-full">
      <h3 class="mb-1">
        <slot name="title"></slot>
      </h3>
      <h4 class="text-gray-400 text-xs">
        <slot name="subtitle"></slot>
      </h4>
      <slot name="after-subtitle"></slot>
    </div>
    <div class="flex-1">
      <slot></slot>
    </div>
  </section>
</template>
